import axios from 'axios';
const ApiBaseURL = process.env.REACT_APP_API_BASE_URL;

const validatePassword: any = (password: string) => {
    const passwordRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
}

const validateEmail: any = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

const countriesCurrencies = [
    { country: 'Italy', currency: 'EUR', symbol: '€' },
    { country: 'Afghanistan', currency: 'USD', symbol: '$' },
    { country: 'Åland Islands', currency: 'USD', symbol: '$' },
    { country: 'Albania', currency: 'USD', symbol: '$' },
    { country: 'Algeria', currency: 'USD', symbol: '$' },
    { country: 'Andorra', currency: 'USD', symbol: '$' },
    { country: 'Angola', currency: 'USD', symbol: '$' },
    { country: 'Anguilla', currency: 'USD', symbol: '$' },
    { country: 'Antigua & Barbuda', currency: 'USD', symbol: '$' },
    { country: 'Argentina', currency: 'USD', symbol: '$' },
    { country: 'Armenia', currency: 'USD', symbol: '$' },
    { country: 'Aruba', currency: 'USD', symbol: '$' },
    { country: 'Ascension Island', currency: 'USD', symbol: '$' },
    { country: 'Australia', currency: 'USD', symbol: '$' },
    { country: 'Austria', currency: 'EUR', symbol: '€' },
    { country: 'Azerbaijan', currency: 'USD', symbol: '$' },
    { country: 'Bahamas', currency: 'USD', symbol: '$' },
    { country: 'Bahrain', currency: 'EUR', symbol: '€' },
    { country: 'Bangladesh', currency: 'USD', symbol: '$' },
    { country: 'Barbados', currency: 'USD', symbol: '$' },
    { country: 'Belarus', currency: 'USD', symbol: '$' },
    { country: 'Belgium', currency: 'EUR', symbol: '€' },
    { country: 'Belize', currency: 'USD', symbol: '$' },
    { country: 'Benin', currency: 'USD', symbol: '$' },
    { country: 'Bermuda', currency: 'USD', symbol: '$' },
    { country: 'Bhutan', currency: 'USD', symbol: '$' },
    { country: 'Bolivia', currency: 'USD', symbol: '$' },
    { country: 'Bosnia & Herzegovina', currency: 'USD', symbol: '$' },
    { country: 'Botswana', currency: 'USD', symbol: '$' },
    { country: 'Brazil', currency: 'USD', symbol: '$' },
    { country: 'British Indian Ocean Territory', currency: 'USD', symbol: '$' },
    { country: 'British Virgin Islands', currency: 'USD', symbol: '$' },
    { country: 'Brunei', currency: 'USD', symbol: '$' },
    { country: 'Bulgaria', currency: 'EUR', symbol: '€' },
    { country: 'Burkina Faso', currency: 'USD', symbol: '$' },
    { country: 'Burundi', currency: 'USD', symbol: '$' },
    { country: 'Cambodia', currency: 'USD', symbol: '$' },
    { country: 'Cameroon', currency: 'USD', symbol: '$' },
    { country: 'Canada', currency: 'USD', symbol: '$' },
    { country: 'Cape Verde', currency: 'USD', symbol: '$' },
    { country: 'Caribbean Netherlands', currency: 'USD', symbol: '$' },
    { country: 'Cayman Islands', currency: 'USD', symbol: '$' },
    { country: 'Central African Republic', currency: 'USD', symbol: '$' },
    { country: 'Chad', currency: 'USD', symbol: '$' },
    { country: 'Chile', currency: 'USD', symbol: '$' },
    { country: 'China', currency: 'USD', symbol: '$' },
    { country: 'Christmas Island', currency: 'USD', symbol: '$' },
    { country: 'Cocos (Keeling) Islands', currency: 'USD', symbol: '$' },
    { country: 'Colombia', currency: 'USD', symbol: '$' },
    { country: 'Comoros', currency: 'USD', symbol: '$' },
    { country: 'Congo - Brazzaville', currency: 'USD', symbol: '$' },
    { country: 'Congo - Kinshasa', currency: 'USD', symbol: '$' },
    { country: 'Cook Islands', currency: 'USD', symbol: '$' },
    { country: 'Costa Rica', currency: 'USD', symbol: '$' },
    { country: 'Côte d’Ivoire', currency: 'USD', symbol: '$' },
    { country: 'Croatia', currency: 'EUR', symbol: '€' },
    { country: 'Curaçao', currency: 'USD', symbol: '$' },
    { country: 'Cyprus', currency: 'EUR', symbol: '€' },
    { country: 'Czechia', currency: 'EUR', symbol: '€' },
    { country: 'Denmark', currency: 'EUR', symbol: '€' },
    { country: 'Djibouti', currency: 'USD', symbol: '$' },
    { country: 'Dominica', currency: 'USD', symbol: '$' },
    { country: 'Dominican Republic', currency: 'USD', symbol: '$' },
    { country: 'Ecuador', currency: 'USD', symbol: '$' },
    { country: 'Egypt', currency: 'USD', symbol: '$' },
    { country: 'El Salvador', currency: 'USD', symbol: '$' },
    { country: 'Equatorial Guinea', currency: 'USD', symbol: '$' },
    { country: 'Eritrea', currency: 'USD', symbol: '$' },
    { country: 'Estonia', currency: 'EUR', symbol: '€' },
    { country: 'Eswatini', currency: 'USD', symbol: '$' },
    { country: 'Ethiopia', currency: 'USD', symbol: '$' },
    { country: 'Falkland Islands', currency: 'USD', symbol: '$' },
    { country: 'Faroe Islands', currency: 'USD', symbol: '$' },
    { country: 'Fiji', currency: 'USD', symbol: '$' },
    { country: 'Finland', currency: 'EUR', symbol: '€' },
    { country: 'France', currency: 'EUR', symbol: '€' },
    { country: 'French Guiana', currency: 'USD', symbol: '$' },
    { country: 'French Polynesia', currency: 'USD', symbol: '$' },
    { country: 'French Southern Territories', currency: 'USD', symbol: '$' },
    { country: 'Gabon', currency: 'USD', symbol: '$' },
    { country: 'Gambia', currency: 'USD', symbol: '$' },
    { country: 'Georgia', currency: 'USD', symbol: '$' },
    { country: 'Germany', currency: 'EUR', symbol: '€' },
    { country: 'Ghana', currency: 'USD', symbol: '$' },
    { country: 'Gibraltar', currency: 'USD', symbol: '$' },
    { country: 'Greece', currency: 'EUR', symbol: '€' },
    { country: 'Greenland', currency: 'USD', symbol: '$' },
    { country: 'Grenada', currency: 'USD', symbol: '$' },
    { country: 'Guadeloupe', currency: 'USD', symbol: '$' },
    { country: 'Guatemala', currency: 'USD', symbol: '$' },
    { country: 'Guernsey', currency: 'USD', symbol: '$' },
    { country: 'Guinea', currency: 'USD', symbol: '$' },
    { country: 'Guinea-Bissau', currency: 'USD', symbol: '$' },
    { country: 'Guyana', currency: 'USD', symbol: '$' },
    { country: 'Haiti', currency: 'USD', symbol: '$' },
    { country: 'Honduras', currency: 'USD', symbol: '$' },
    { country: 'Hong Kong SAR', currency: 'USD', symbol: '$' },
    { country: 'Hungary', currency: 'EUR', symbol: '€' },
    { country: 'Iceland', currency: 'USD', symbol: '$' },
    { country: 'India', currency: 'USD', symbol: '$' },
    { country: 'Indonesia', currency: 'USD', symbol: '$' },
    { country: 'Iraq', currency: 'USD', symbol: '$' },
    { country: 'Ireland', currency: 'EUR', symbol: '€' },
    { country: 'Isle of Man', currency: 'USD', symbol: '$' },
    { country: 'Israel', currency: 'USD', symbol: '$' },
    { country: 'Jamaica', currency: 'USD', symbol: '$' },
    { country: 'Japan', currency: 'USD', symbol: '$' },
    { country: 'Jersey', currency: 'USD', symbol: '$' },
    { country: 'Jordan', currency: 'USD', symbol: '$' },
    { country: 'Kazakhstan', currency: 'USD', symbol: '$' },
    { country: 'Kenya', currency: 'USD', symbol: '$' },
    { country: 'Kiribati', currency: 'USD', symbol: '$' },
    { country: 'Kosovo', currency: 'USD', symbol: '$' },
    { country: 'Kuwait', currency: 'EUR', symbol: '€' },
    { country: 'Kyrgyzstan', currency: 'USD', symbol: '$' },
    { country: 'Laos', currency: 'USD', symbol: '$' },
    { country: 'Latvia', currency: 'EUR', symbol: '€' },
    { country: 'Lebanon', currency: 'USD', symbol: '$' },
    { country: 'Lesotho', currency: 'USD', symbol: '$' },
    { country: 'Liberia', currency: 'USD', symbol: '$' },
    { country: 'Libya', currency: 'USD', symbol: '$' },
    { country: 'Liechtenstein', currency: 'EUR', symbol: '€' },
    { country: 'Lithuania', currency: 'EUR', symbol: '€' },
    { country: 'Luxembourg', currency: 'EUR', symbol: '€' },
    { country: 'Macao SAR', currency: 'USD', symbol: '$' },
    { country: 'Madagascar', currency: 'USD', symbol: '$' },
    { country: 'Malawi', currency: 'USD', symbol: '$' },
    { country: 'Malaysia', currency: 'USD', symbol: '$' },
    { country: 'Maldives', currency: 'USD', symbol: '$' },
    { country: 'Mali', currency: 'USD', symbol: '$' },
    { country: 'Malta', currency: 'EUR', symbol: '€' },
    { country: 'Martinique', currency: 'USD', symbol: '$' },
    { country: 'Mauritania', currency: 'USD', symbol: '$' },
    { country: 'Mauritius', currency: 'USD', symbol: '$' },
    { country: 'Mayotte', currency: 'USD', symbol: '$' },
    { country: 'Mexico', currency: 'USD', symbol: '$' },
    { country: 'Moldova', currency: 'USD', symbol: '$' },
    { country: 'Monaco', currency: 'USD', symbol: '$' },
    { country: 'Mongolia', currency: 'USD', symbol: '$' },
    { country: 'Montenegro', currency: 'USD', symbol: '$' },
    { country: 'Montserrat', currency: 'USD', symbol: '$' },
    { country: 'Morocco', currency: 'USD', symbol: '$' },
    { country: 'Mozambique', currency: 'USD', symbol: '$' },
    { country: 'Myanmar (Burma)', currency: 'USD', symbol: '$' },
    { country: 'Namibia', currency: 'USD', symbol: '$' },
    { country: 'Nauru', currency: 'USD', symbol: '$' },
    { country: 'Nepal', currency: 'USD', symbol: '$' },
    { country: 'Netherlands', currency: 'EUR', symbol: '€' },
    { country: 'New Caledonia', currency: 'USD', symbol: '$' },
    { country: 'New Zealand', currency: 'USD', symbol: '$' },
    { country: 'Nicaragua', currency: 'USD', symbol: '$' },
    { country: 'Niger', currency: 'USD', symbol: '$' },
    { country: 'Nigeria', currency: 'USD', symbol: '$' },
    { country: 'Niue', currency: 'USD', symbol: '$' },
    { country: 'Norfolk Island', currency: 'USD', symbol: '$' },
    { country: 'North Macedonia', currency: 'USD', symbol: '$' },
    { country: 'Norway', currency: 'EUR', symbol: '€' },
    { country: 'Oman', currency: 'EUR', symbol: '€' },
    { country: 'Pakistan', currency: 'USD', symbol: '$' },
    { country: 'Palestinian Territories', currency: 'USD', symbol: '$' },
    { country: 'Panama', currency: 'USD', symbol: '$' },
    { country: 'Papua New Guinea', currency: 'USD', symbol: '$' },
    { country: 'Paraguay', currency: 'USD', symbol: '$' },
    { country: 'Peru', currency: 'USD', symbol: '$' },
    { country: 'Philippines', currency: 'USD', symbol: '$' },
    { country: 'Pitcairn Islands', currency: 'USD', symbol: '$' },
    { country: 'Poland', currency: 'EUR', symbol: '€' },
    { country: 'Portugal', currency: 'EUR', symbol: '€' },
    { country: 'Qatar', currency: 'USD', symbol: '$' },
    { country: 'Réunion', currency: 'USD', symbol: '$' },
    { country: 'Romania', currency: 'EUR', symbol: '€' },
    { country: 'Russia', currency: 'USD', symbol: '$' },
    { country: 'Rwanda', currency: 'USD', symbol: '$' },
    { country: 'Samoa', currency: 'USD', symbol: '$' },
    { country: 'San Marino', currency: 'USD', symbol: '$' },
    { country: 'São Tomé & Príncipe', currency: 'USD', symbol: '$' },
    { country: 'Saudi Arabia', currency: 'USD', symbol: '$' },
    { country: 'Senegal', currency: 'USD', symbol: '$' },
    { country: 'Serbia', currency: 'USD', symbol: '$' },
    { country: 'Seychelles', currency: 'USD', symbol: '$' },
    { country: 'Sierra Leone', currency: 'USD', symbol: '$' },
    { country: 'Singapore', currency: 'USD', symbol: '$' },
    { country: 'Sint Maarten', currency: 'USD', symbol: '$' },
    { country: 'Slovakia', currency: 'EUR', symbol: '€' },
    { country: 'Slovenia', currency: 'EUR', symbol: '€' },
    { country: 'Solomon Islands', currency: 'USD', symbol: '$' },
    { country: 'Somalia', currency: 'USD', symbol: '$' },
    { country: 'South Africa', currency: 'USD', symbol: '$' },
    { country: 'South Georgia & South Sandwich Islands', currency: 'USD', symbol: '$' },
    { country: 'South Korea', currency: 'USD', symbol: '$' },
    { country: 'South Sudan', currency: 'USD', symbol: '$' },
    { country: 'Spain', currency: 'EUR', symbol: '€' },
    { country: 'Sri Lanka', currency: 'USD', symbol: '$' },
    { country: 'St. Barthélemy', currency: 'USD', symbol: '$' },
    { country: 'St. Helena', currency: 'USD', symbol: '$' },
    { country: 'St. Kitts & Nevis', currency: 'USD', symbol: '$' },
    { country: 'St. Lucia', currency: 'USD', symbol: '$' },
    { country: 'St. Martin', currency: 'USD', symbol: '$' },
    { country: 'St. Pierre & Miquelon', currency: 'USD', symbol: '$' },
    { country: 'St. Vincent & Grenadines', currency: 'USD', symbol: '$' },
    { country: 'Sudan', currency: 'USD', symbol: '$' },
    { country: 'Suriname', currency: 'USD', symbol: '$' },
    { country: 'Svalbard & Jan Mayen', currency: 'USD', symbol: '$' },
    { country: 'Sweden', currency: 'EUR', symbol: '€' },
    { country: 'Switzerland', currency: 'CHF', symbol: 'CHF ' },
    { country: 'Taiwan', currency: 'USD', symbol: '$' },
    { country: 'Tajikistan', currency: 'USD', symbol: '$' },
    { country: 'Tanzania', currency: 'USD', symbol: '$' },
    { country: 'Thailand', currency: 'USD', symbol: '$' },
    { country: 'Timor-Leste', currency: 'USD', symbol: '$' },
    { country: 'Togo', currency: 'USD', symbol: '$' },
    { country: 'Tokelau', currency: 'USD', symbol: '$' },
    { country: 'Tonga', currency: 'USD', symbol: '$' },
    { country: 'Trinidad & Tobago', currency: 'USD', symbol: '$' },
    { country: 'Tristan da Cunha', currency: 'USD', symbol: '$' },
    { country: 'Tunisia', currency: 'USD', symbol: '$' },
    { country: 'Türkiye', currency: 'USD', symbol: '$' },
    { country: 'Turkmenistan', currency: 'USD', symbol: '$' },
    { country: 'Turks & Caicos Islands', currency: 'USD', symbol: '$' },
    { country: 'Tuvalu', currency: 'USD', symbol: '$' },
    { country: 'U.S. Outlying Islands', currency: 'USD', symbol: '$' },
    { country: 'Uganda', currency: 'USD', symbol: '$' },
    { country: 'Ukraine', currency: 'USD', symbol: '$' },
    { country: 'United Arab Emirates', currency: 'USD', symbol: '$' },
    { country: 'United Kingdom', currency: 'GBP', symbol: '£' },
    { country: 'United States', currency: 'USD', symbol: '$' },
    { country: 'Uruguay', currency: 'USD', symbol: '$' },
    { country: 'Uzbekistan', currency: 'USD', symbol: '$' },
    { country: 'Vanuatu', currency: 'USD', symbol: '$' },
    { country: 'Vatican City', currency: 'USD', symbol: '$' },
    { country: 'Venezuela', currency: 'USD', symbol: '$' },
    { country: 'Vietnam', currency: 'USD', symbol: '$' },
    { country: 'Wallis & Futuna', currency: 'USD', symbol: '$' },
    { country: 'Western Sahara', currency: 'USD', symbol: '$' },
    { country: 'Yemen', currency: 'USD', symbol: '$' },
    { country: 'Zambia', currency: 'USD', symbol: '$' },
    { country: 'Zimbabwe', currency: 'USD', symbol: '$' },
];

export { validateEmail, validatePassword, countriesCurrencies};
